import { atom } from 'recoil';

export const projectUrl = atom({
  key: 'projectUrl',
  default: {
    projectUrlTitle: '案件登録お申し込みはこちら',
    projectUrl: '',
  },
});
